var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noData-tip"},[_c('div',{staticClass:"noData-img"},[_c('img',{staticClass:"img",attrs:{"src":_vm.noDataImage}}),_c('p',[_vm._v("还没有任何消息~")])])])}
var staticRenderFns = []

export { render, staticRenderFns }